import { render, staticRenderFns } from "./CheckBold.vue?vue&type=template&id=225fad52&"
import script from "./CheckBold.vue?vue&type=script&setup=true&lang=js&"
export * from "./CheckBold.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports